import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const ServiceCard = ({ 
  service, 
  isReversed = false 
}) => {
  const { id, icon: Icon, title, description, color, capabilities } = service;

  return (
    <div 
      id={id}
      className={`flex flex-col ${isReversed ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 items-center`}
    >
      {/* Icon/Visual */}
      <div className="lg:w-1/3 flex justify-center">
        <div 
          className="w-48 h-48 rounded-3xl flex items-center justify-center card-hover"
          style={{ 
            backgroundColor: `${color}15`,
            border: `1px solid ${color}30`
          }}
        >
          <Icon className="w-24 h-24" style={{ color }} />
        </div>
      </div>

      {/* Content */}
      <div className="lg:w-2/3">
        <div className="flex items-center gap-3 mb-4">
          <div 
            className="w-10 h-10 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: `${color}20` }}
          >
            <Icon className="w-5 h-5" style={{ color }} />
          </div>
          <h2 className="text-2xl sm:text-3xl font-bold text-[#f1f5f9]">
            {title}
          </h2>
        </div>

        <p className="text-[#94a3b8] text-lg mb-8 leading-relaxed">
          {description}
        </p>

        <div className="bg-[#162544] rounded-2xl p-6 border border-[#1e3a5f]/50">
          <h3 className="text-sm font-semibold text-[#64748b] uppercase tracking-wider mb-4">
            Capabilities
          </h3>
          <div className="grid sm:grid-cols-2 gap-4">
            {capabilities.map((cap) => (
              <div key={cap.text} className="flex items-center gap-3">
                <CheckCircle2 className="w-5 h-5 flex-shrink-0" style={{ color }} />
                <span className="text-[#f1f5f9]">{cap.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
